<div class="card-list">
	<p class="title-xs font-serra">Pages du binder</p>
</div>

<dialog #dlg id="my_modal_3" class="modal">
  <div class="modal-box w-full">
    <form method="dialog">
      <button (click)="opened.set(false)" class="absolute right-4 top-4"><i class="fa-light fa-xmark"></i></button>
    </form>

    <!-- carousel dans le fullscreen -->
		<div #modalCaroussel class="carousel w-full rounded-box">
			@for(page of pages(); track page.ident; let i=$index){
			  <div #carouselItem class="carousel-item w-full">
			  	 <div>
					   <img hSkeleton="427px" wSkeleton="300px" [src]="getImgPage(page)" class="w-full rounded-box" [attr.loading]="((i>10)? 'lazy' : null)"/>
					   @if(isFinish(page) && admin()){
						   <div class="actions-container">
						   		<lgb-share [element]="page" typeElement="page">
							   		<span class="add-fav glass rounded-full bg-black/40 mb-3">
							   			<i class="fa-light fa-paper-plane"></i>
								    </span>
								  </lgb-share>
						   </div>
						 }
						 @else if(!isFinish(page)){
							<div class="progress-component">
								<lgb-progress></lgb-progress>
							</div>
						 }
					 </div>
			  </div>
			}
		</div>

		<!-- message swap -->
		@if(opened()){
			<lgb-swipe-hint></lgb-swipe-hint>
		}

  </div>
</dialog>

@if(!pages().length){
	<div class="empty-container">
		<img src="img/skin/empty-card.svg"/>
			<p class="subtitle mb-4">
				Pas encore de pages ici.<br/>
				Scanne une page pour lancer ta collection.
			</p>
			@if(admin()){
				<button (click)="scanService.enable('binder', uBinder().ident)" class="btn btn-primary btn-gradient mb-4">Commencer</button>
			}
	</div>
}
@else{
	<div class="list-page-container">
		@for(page of pages(); track page.ident; let i=$index){
			<div [ngClass]="{'element-show': !fragment()}" class="page-item" [style.--i]="i">
				<lgb-page-item 
					[admin]="admin()"
					(fullScreen)="openDialog(i)"
					[page]="page"
					[scan]="getScanPage(page.scan)"
					[lazy]="i>10"
				></lgb-page-item>
			</div>
 		}
	</div>
}